import React, { Fragment, useMemo } from 'react';
import Table from 'react-bootstrap/Table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faPen,
  faTrashCan,
  faEye,
  faBars
} from '@fortawesome/free-solid-svg-icons';

import './CustomTable.css';
import TablePagination from './TablePagination';

function CustomTable({
  headers,
  rows,
  onEdit = null,
  onRemove = null,
  onShow = null,
  allData = {},
  setPage,
  page,
  changePermissions
}) {
  const columnsHeader = useMemo(
    () =>
      headers.map((item, index) => (
        <th key={index} align="center">
          {item.title}
        </th>
      )),
    [headers]
  );

  const rowsBody = useMemo(
    () =>
      rows.map(item => (
        <tr key={item.id}>
          {Object.entries(item).map(([key, value]) => (
            <td key={key} align="center">
              {value}
            </td>
          ))}

          {Boolean(onEdit) && (
            <td align="center">
              <FontAwesomeIcon
                icon={faPen}
                onClick={() => onEdit(item)}
                className="icon"
              />
            </td>
          )}

          {Boolean(onRemove) && (
            <td align="center">
              <FontAwesomeIcon
                icon={faTrashCan}
                onClick={() => onRemove(item.id)}
                className="icon"
              />
            </td>
          )}

          {Boolean(onShow) && (
            <td align="center">
              <FontAwesomeIcon
                icon={faEye}
                onClick={() => onShow(item.id)}
                className="icon"
              />
            </td>
          )}

          {Boolean(changePermissions) && (
            <td align="center">
              <FontAwesomeIcon
                icon={faBars}
                onClick={() => changePermissions(item.id, item.nombre)}
                className="icon"
              />
            </td>
          )}
        </tr>
      )),
    [rows, onEdit, onRemove, onShow, changePermissions]
  );

  return (
    <Fragment>
      <Table className="custom-table">
        <thead>
          <tr>{columnsHeader}</tr>
        </thead>
        <tbody>{rowsBody}</tbody>
      </Table>
      {allData.current_page && (
        <TablePagination
          currentPage={allData.current_page}
          lastPage={allData.last_page}
          setPage={setPage}
          page={page}
        />
      )}
    </Fragment>
  );
}

export default CustomTable;
